module.exports = __webpack_public_path__ + "static/media/anatomia.4c9c9e4f.png";